import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/ui/components/ui/card.tsx";
import { ArrowUp, ArrowDown } from "lucide-react";
import { useTranslation } from "react-i18next";
import { formatNumber } from "@/shared/lib/i18n/formatters.ts";

interface KpiStatsCardProps {
  title: string;
  current: string;
  previous?: string;
  changePercent?: {
    value: number;
    direction: "up" | "down";
  } | null;
  icon?: React.ReactNode;
}

const KpiStatsCard = ({
                        title,
                        current,
                        previous,
                        changePercent,
                        icon,
                      }: KpiStatsCardProps) => {
  const { t } = useTranslation("machines");
  const isPositive = changePercent?.direction === "up";

  return (
    <Card>
      <CardHeader className="pb-4">
        <CardTitle className="flex justify-between items-start">
          <div className="flex items-center gap-2">
            {icon && <span className="text-muted-foreground">{icon}</span>}
            <span>{current}</span>
          </div>
          {changePercent && (
            <div
              className={`flex items-center gap-1 ${
                isPositive ? "text-green-500" : "text-red-500"
              }`}
            >
              {isPositive ? <ArrowUp size={14} /> : <ArrowDown size={14} />}
              {t("units.percent", { value: formatNumber(changePercent.value, { minimumFractionDigits: 1, maximumFractionDigits: 1 }) })}
            </div>
          )}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <CardDescription>{title}</CardDescription>
        {previous && <div className="text-xs text-muted-foreground mt-1">
          {t("kpiStats.previous", { value: previous })}
        </div>}
      </CardContent>
    </Card>
  );
};

export default KpiStatsCard;
